<template>
  <div class="productsBox" @scroll="getScroll">
    <nav class="nav">
      <div class="navBox">
        <!-- 左侧按钮 -->
        <div
          class="iconLeft"
          :style="startIndex == 0 ? 'color:#CCCCCC' : 'color:#3e79fe;'"
          style="position: absolute; left: 0px; top: 50%"
          @click="tabLeft"
        >
          <i class="el-icon-arrow-left fontS" />
        </div>
        <!-- 右侧按钮 -->
        <div
          class="iconRight"
          :style="
            endIndex == tabsList.length - 1 ? 'color:#CCCCCC' : 'color:#3e79fe;'
          "
          style="position: absolute; right: 0px; top: 50%"
          @click="tabRight"
        >
          <i class="el-icon-arrow-right fontS" />
        </div>
        <!-- 中间内容 -->
        <div id="box" class="box">
          <div
            class="good_city"
            :style="'transform: translateX(' + tabIndex + 'px);'"
          >
            <div class="tabsBox">
              <div
                v-for="(item, index) in tabsList"
                :id="'tab' + item.value"
                :key="item.value"
                class="tab"
                @click="clickTab(item, index)"
              >
                <!-- :class="tabClick == item.id ? 'tabClick' : ''" -->
                <img class="imgBox" :src="item.img" alt="" />
                {{ item.title }}
                <div :class="{ active: index == currentActive }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="navTwo">
      <div class="navBoxTwo">
        <div
          v-for="(item, index) in tabsList"
          :id="'tabTwo' + item.value"
          :key="item.value"
          class="tabTwo"
          @click="clickTab(item, index)"
        >
          <!-- :class="tabClick == item.id ? 'tabClick' : ''" -->
          <img class="imgBox" :src="item.img" alt="" />
          {{ item.title }}
          <!-- <div :class="{ active: index == currentActive }"></div> -->
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="conInside">
        <span class="conTitle">{{ currentTitle }}</span>
        <div class="productBox">
          <div
            class="contentItemBox"
            v-for="(item, index) in productList"
            :key="index"
            @click="toProductDetail(item)"
          >
            <img class="imgBox" :src="item.img" alt="" />
            <div class="conItem">{{ item.title }}</div>
            <p class="conText">{{ item.content }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
// import { productObj } from '@/static/products.js'
export default {
  name: 'products',
  data () {
    return {
      currentActive: 0,
      currentTitle: 'Products category one',
      tabClick: 0, // 选择的tab
      tabIndex: 0, // tab需要移动的宽
      startIndex: 0, // display展示的起始div索引
      endIndex: 0, // display展示的终止div索引
      currentPage: 1, // 当前页
      pageSize: 12, // 一页12条
      total: 0,
      timer: '',
      isloading: false,
      tabsList: [],
      productList: [],
      productObj: {},
      allList: []
    }
  },

  activated () {
    console.log('activated')
    window.addEventListener('scroll', this.getScroll)
  },
  created () {
    this.tabsList = JSON.parse(window.sessionStorage.getItem('homeData'))
  },
  mounted () {
    console.log('mounted')
    this.getTabWidth()
    this.setDisplayTab(0)
    window.addEventListener('scroll', this.getScroll)
  },
  methods: {
    getTabWidth () {
      this.tabsList.forEach((item, index) => {
        this.tabsList[index].width = document.getElementById(
          'tab' + item.value
        ).clientWidth
      })
      // console.log(this.tabsList)
    },
    setDisplayTab (inx) {
      // 参数：起始索引
      // 当前展示起始索引startIndex，box宽度，计算<box的索引endIndex，start-end展示，其他隐藏
      // 可展示区域宽度 -- 即box div宽度
      this.fatherWidth = document.getElementById('box').clientWidth
      let sumWidth = 0
      this.tabsList.forEach((item, index) => {
        if (index >= inx) {
          sumWidth = sumWidth + item.width + 10
          // this.endIndex = index;
          if (this.fatherWidth >= sumWidth) {
            document.getElementById('tab' + item.value).style.display = 'flex'
            // 'inline-block'
            this.endIndex = index
          } else {
            document.getElementById('tab' + item.value).style.display = 'none'
          }
        }
      })
    },
    clickTab (item, index) {
      this.$router.push({
        path: 'products',
        query: {
          num: index + 1
        }
      })
    },
    tabLeft () {
      // 移动距离tabindex=startIndex-1的宽度，调用setDisplayTab控制显隐
      // 判断是否为初始位置
      if (this.startIndex !== 0) {
        // 向左移动，起始位置-1
        this.startIndex--
        this.setDisplayTab(this.startIndex)
        this.tabIndex += this.tabsList[this.startIndex].width + 30
      }
    },
    tabRight () {
      if (this.endIndex < this.tabsList.length - 1) {
        const tabStartBeforeIndex = this.startIndex
        this.startIndex++
        this.setDisplayTab(this.startIndex)
        this.tabIndex -= this.tabsList[tabStartBeforeIndex].width + 30
      }
    },
    toProductDetail (item) {
      console.log(item)
      if (item.type == 1) {
        this.$router.push({
          path: '/productsDetailTwo',
          query: {
            id: item.id
          }
        })
      } else if (item.type == 2) {
        this.$router.push({
          path: '/productsDetailThree',
          query: {
            id: item.id
          }
        })
      } else if (item.type == 3) {
        this.$router.push({
          path: '/productsDetail',
          query: {
            id: item.id
          }
        })
      }
    },
    getScroll () {
      let clientHeight = document.documentElement.clientHeight - 18 //可视区域
      let scrollHeight = document.body.scrollHeight // 滚动文档高度
      let scrollTop = parseInt(document.documentElement.scrollTop) // 已滚动的高度
      let height = 300
      if (
        scrollTop + clientHeight >= scrollHeight - height &&
        scrollHeight != 0
      ) {
        if ((this.currentPage - 1) * this.pageSize >= this.total) {
          return
        }
        if (!this.isloading) {
          this.isloading = true
          this.currentPage++
          // this.timer = setTimeout(() => {
          let begin = (this.currentPage - 1) * this.pageSize
          let end = this.currentPage * this.pageSize
          // let spliceList = this.allList.splice(begin, end)
          this.productList = [
            ...this.productList,
            ...this.allList.slice(begin, end)
          ].sort(function (a, b) {
            return a.number - b.number
          })
          this.isloading = false
          // console.log('this.total', this.total)
          // }, 100)
        }
      }
    }
  },
  watch: {
    $route: {
      handler: function (newVal) {
        if (Object.keys(this.productObj).length === 0) {
          this.productObj = JSON.parse(
            window.sessionStorage.getItem('productObj')
          )
        }
        let number = newVal.query.num
        this.currentPage = 1
        this.pageSize = 12
        this.allList = this.productObj[number]
        if (this.allList) {
          this.total = this.allList.length
          this.productList = this.allList.slice(0, 12).sort(function (a, b) {
            return a.number - b.number
          })
        }

        if (number == 1) {
          this.currentTitle = 'Antenna'
        } else if (number == 2) {
          this.currentTitle = '2G/3G/4G Radio'
        } else if (number == 3) {
          this.currentTitle = '4G/5G CPE'
        } else if (number == 4) {
          this.currentTitle = 'GPON OLT/ONT'
        } else if (number == 5) {
          this.currentTitle = 'Optical Fiber accessories'
        } else if (number == 6) {
          this.currentTitle = 'Optical Transmission'
        } else if (number == 7) {
          this.currentTitle = 'Server'
        } else if (number == 8) {
          this.currentTitle = 'Storage'
        } else if (number == 9) {
          this.currentTitle = 'Telecom Power'
        }
        this.currentActive = newVal.query.num * 1 - 1
      },
      immediate: true
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.getScroll)
  },
  // deactivated () {
  //   window.removeEventListener('scroll', this.getScroll)
  // }
}
</script>

<style lang="less" scoped>
.productsBox {
  .nav {
    width: 100%;
    height: 250px;
    background-color: #d7d7d7;
    .navBox {
      position: relative;
      width: 1150px;
      margin: 0 auto;

      .iconLeft {
        text-align: center;
        padding: 8px;
        cursor: pointer;
        // background-color: white;
        transform: translateY(-50%);
        z-index: 99;
        .fontS {
          font-size: 50px;
          color: #555555;
          font-weight: 700;
        }
      }
      .iconRight {
        text-align: center;
        padding: 8px;
        cursor: pointer;
        // background-color: white;
        transform: translateY(-50%);
        z-index: 99;
        .fontS {
          font-size: 50px;
          color: #555555;
          font-weight: 700;
        }
      }
      .box {
        height: 250px;
        margin: 0 70px;
        overflow: hidden;

        .good_city {
          width: 9999px; //这里其实不应该写死 应该写成动态赋值 这里我就先写死
          height: 250px;
          transition: all 0.5s;
        }
        .tabsBox {
          width: 9999px;
          height: 250px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: nowrap;
          overflow: hidden;
          align-items: center;
          .tab {
            height: 180px;
            width: 180px;
            margin: 0 10px;
            cursor: pointer;
            background: #fff;
            border-radius: 10px;
            // justify-content: space-evenly;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            color: #0057b8;
            font-weight: 600;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            text-align: center;
            .imgBox {
              width: 100px;
              height: 100px;
              margin-bottom: 10px;
            }
            .active {
              position: absolute;
              bottom: 15px;
              width: 150px;
              height: 5px;
              background-color: #0057b8;
            }
          }
          .tabClick {
            background: #3e79fe;
            color: #ffffff;
          }
        }
      }
    }
  }
  .navTwo {
    display: block;
    height: 200px;
    background-color: #d7d7d7;
    .navBoxTwo {
      height: 100%;
      width: 1000px;
      margin: 0 auto;
      display: flex;
      overflow-x: scroll;
      align-items: center;
      .tabTwo {
        font-size: 12px;
        height: 120px;
        margin: 10px 10px;
        padding: 0 20px;
        cursor: pointer;
        background: #fff;
        border-radius: 10px;
        color: #0057b8;
        font-weight: 600;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .imgBox {
          width: 70px;
          height: 70px;
          // margin-bottom: 10px;
        }
      }
    }
  }

  .contentBox {
    // padding: 20px 350px;
    width: 100%;
    background-color: #f5f5f5;
    .conInside {
      width: 1200px;
      margin: 0 auto;
      .conTitle {
        font-size: 28px;
        font-weight: 700;
        border-bottom: 4px solid #0057b8;
        padding: 10px 0;
        color: #0057b8;
        display: inline-block;
      }
      .productBox {
        padding: 20px 0px;
        display: flex;
        flex-wrap: wrap;
        // margin-right: 10px;
        // justify-content: space-between;

        .contentItemBox {
          // margin: 20px 0;
          width: 260px;
          height: 300px;
          background-color: #fff;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: space-evenly;
          margin: 20px;
          cursor: pointer;
          transition: all 0.5s;
          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          font-size: 14px;
          .imgBox {
            width: 150px;
            height: 100px;
          }
          .conItem {
            // width: 200px;
            border: 1px solid #2b7fd9;
            border-radius: 20px;
            text-align: center;
            padding: 5px 10px;
            color: #2b7fd9;
          }
          .conItem:hover {
            background-color: #d8e7f8;
            // color: #5d95c6;
          }
          .conText {
            text-align: center;
            padding: 0 10px;
          }
        }
        .contentItemBox:hover {
          scale: 1.1;
          transition: all 0.5s;
        }
      }
    }
  }
  //当屏幕最小宽度为1300px
  @media screen and (min-width: 1300px) {
    .nav {
      display: block;
      .navBox {
        .box {
          .good_city {
            .tabsBox {
              .tab {
                display: flex !important;
              }
            }
          }
        }
      }
      .tabsBox {
        display: block;
      }
    }
    .navTwo {
      display: none;
    }
    .contentBox {
      .conInside {
        transition: width 0.3s ease-in-out;
      }
    }
  }
  //当屏幕宽度 最小为800px 最大为1300px时
  @media screen and (min-width: 1000px) and (max-width: 1300px) {
    .nav {
      display: none;
    }
    .navTwo {
      display: block;
      .navBoxTwo {
        width: 900px;
        transition: width 0.3s ease-in-out;
      }
    }
    .contentBox {
      .conInside {
        width: 1000px;
        transition: width 0.3s ease-in-out;
      }
    }
  }
  //当屏幕宽度 最小为800px 最大为1300px时
  @media screen and (min-width: 800px) and (max-width: 1000px) {
    .nav {
      display: none;
    }
    .navTwo {
      display: block;
      .navBoxTwo {
        width: 700px;
        transition: width 0.3s ease-in-out;
      }
    }
    .contentBox {
      .conInside {
        width: 700px;
        transition: width 0.3s ease-in-out;
      }
    }
  }
  //当屏幕最大宽度为800px
  @media screen and (max-width: 800px) {
    .nav {
      display: none;
    }
    .navTwo {
      display: block;
      .navBoxTwo {
        width: 90%;
        margin: 0 20px;
        transition: width 0.3s ease-in-out;
      }
    }
    .contentBox {
      .conInside {
        width: 100%;
        transition: width 0.3s ease-in-out;
        .conTitle {
          font-size: 16px;
          margin: 10px 0 0 10px;
          display: inline-block;
          border-bottom: 2px solid #0057b8;
        }
        .productBox {
          // padding: 10px 0px;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          // margin-right: 10px;
          // justify-content: space-between;

          .contentItemBox {
            margin: 10px;
            width: 150px;
            height: 200px;
            font-size: 12px;
            .imgBox {
              width: 100px;
              height: 50px;
            }
            .conItem {
              width: 100px;
              border-radius: 10px;
              padding: 5px 10px;
            }

            .conText {
              text-align: center;
              padding: 0 5px;
            }
          }
          .contentItemBox:hover {
            scale: 1.1;
            transition: all 0.5s;
          }
        }
      }
    }
  }
}
</style>
